import _sfc_main from "./TimepickerPC.vue2.mjs";
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "container" }, [_c(_setup.TuiSelect, { staticClass: "timepicker-select", attrs: { "theme": "white", "teleported": false, "custom-select-content-style": { "font-weight": 400 } }, model: { value: _setup.selectedTime, callback: function($$v) {
    _setup.selectedTime = $$v;
  }, expression: "selectedTime" } }, _vm._l(_setup.timeOptions, function(time) {
    return _c(_setup.TuiOption, { key: time, attrs: { "theme": "white", "value": time, "label": time, "custom-option-content-style": { "font-weight": 400 } } });
  }), 1)], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const TimepickerPC = __component__.exports;
export {
  TimepickerPC as default
};
